module.exports = __webpack_public_path__ + "static/media/curriculum_s4.634566c5.png";